export const BRAND = {
  name: "New Era",
  legalName: "New Era Soluções em Tecnologia Digital e Segurança LTDA",
  logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_02c3a2dc-ea07-405e-bd9c-e05d10b0adc7/artifacts/11e56a7c8fbfcb22_WhatsApp%20Image%202026-10-16%20at%2012.43.02%20%281%29.jpeg",
  whatsapp: "5511999998888",
  email: "contato@newera.tech",
  heroImage: "https://images.pexels.com/photos/33349204/pexels-photo-33349204.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  images: {
    security: "https://images.unsplash.com/photo-1581193633211-42cf83aaa734?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxjeWJlciUyMHNlY3VyaXR5JTIwc29mdHdhcmUlMjBkZXZlbG9wbWVudHxlbnwwfHx8Z3JlZW58MTc5MjE2OTM2N3ww&ixlib=rb-4.1.0&q=85",
    infrastructure: "https://images.unsplash.com/photo-1782094673136-5198a372980c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHx0ZWNobm9sb2d5JTIwc2VydmVyJTIwcm9vbSUyMGdsb3d8ZW58MHx8fHwxNzkyMTY5MzY3fDA&ixlib=rb-4.1.0&q=85",
    consulting: "https://images.pexels.com/photos/6424583/pexels-photo-6424583.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
};

export const whatsappLink = (message) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(message)}`;

export const scrollToSection = (id) => {
  const target = `#${id}`;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -80, duration: 1.4 });
  } else {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }
};
